import {
  intersectionWatcher,
  delayOffset,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  sectionIntro: ".animation--section-introduction > *",
  textColumns: ".text-columns__feature",
};

export default node => {
  if (!shouldAnimate(node)) return;

  delayOffset(node, [selectors.sectionIntro, selectors.textColumns]);

  const observer = intersectionWatcher(node, true);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
